<template>
  <div>
    <div class="headbt">
      <span class="zjt" @click="fh"><img src="../../assets/img/zjt.png" ></span>在线咨询&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
    </div>


<div class="uinfo">

        <div class="uinfo_1">
        			<ul class="list-group">
        			 <li class="list-group-item  userliebiao">
        			 	<div class=" col-sm-4 col-4 col-md-4" style="font-size: 14px !important;">
        					<span class="xingxing" >*</span>姓名
        				</div>
        				<div class=" col-sm-8 col-8 col-md-8" >
        					<input v-model="form.createName" disabled  type="text" class="form-control" placeholder="请输入联系人姓名"/>
        				</div>
        			 </li>


        			<li class="list-group-item  userliebiao">
        				<div class=" col-sm-4 col-4 col-md-4"  style="font-size: 14px !important;">
        					<span class="xingxing">*</span>联系电话
        				</div>
        				<div class=" col-sm-8 col-8 col-md-8" >
        					<input  v-model="form.iphone"  type="number" class="form-control" placeholder="请输入联系电话"/>
        				</div>
        			</li>
        			<li class="list-group-item  userliebiao">
        				<div class=" col-sm-4 col-4 col-md-4" style="font-size: 14px !important;">
        					<span class="xingxing" >*</span>咨询内容
        				</div>
        				<div class=" col-sm-8 col-8 col-md-8"  style="font-size: 14px !important;">
        					<textarea  class="zxnr" v-model="form.consultationContent" placeholder="请输入要咨询的内容"></textarea>
        				</div>
        			</li>

              <li class="list-group-item  userliebiao" style="border-bottom: none !important;">
              	<div class=" col-sm-12 col-12 col-md-12" >
                    <div class="zzz" @click="tj">
                        确定
                    </div>
              	</div>

              </li>
        			</ul>
        			</div>

    </div>


    <div class="bkx">

    </div>


  </div>
</template>

<script>
import {addzx } from '../../api/baseset'
  export default {
      data() {
        return {
          form:{
            createName:'',
            iphone:'',
            consultationContent:''
          }
        }
      },
      mounted() {
      //this.getdata();
     // this.getsjtjs();
       const user_infos = JSON.parse(localStorage.getItem('user_infos'))
       this.form.createName = user_infos.nickName;
       this.form.iphone = user_infos.phonenumber;
       //console.log(data)
      },
      methods: {
        tz(url){

          this.$router.push(url);
        },
        fh(){
         window.history.go(-1);
        },
        tj(){

          if(this.form.createName == ''){
             this.$message.error('姓名不能为空！')
            return ;
          }
          let check_tel = this.isValidPhoneNumber(this.form.iphone)
          if(check_tel == false){
            this.$message.error('请输入正确的手机号！')
            return ;
          }
          if(this.form.consultationContent == ''){
             this.$message.error('咨询内容不能为空！')
            return ;
          }
          this.loading = true
          //let param={pageNum:this.page,pageSize:this.limit}
             addzx(this.form)
              .then(res => {

                this.loading = false
                if (res.code != 200) {
                  this.$message({
                    type: 'info',
                    message: res.msg
                  })
                } else {
                    this.$message({
                      type: 'success',
                      message: '提交成功，稍后我们的工作人员会电话联系你！'
                    })
                     this.$router.push('/user/kefu');
                }
              })
              .catch(err => {
                this.loading = false
                this.$message.error('数据加载失败，请稍后再试！')
              })

          /* this.$message.success('提交成功，稍后我们的工作人员会电话联系你！')
           this.$router.push('/user/kefu'); */
        },
        isValidPhoneNumber(phoneNumber) {
            return /^1[3-9]\d{9}$/.test(phoneNumber);
        }

      }
    }
  </script>

<style scoped>
  	body{
  			background-color: #EFEFF4;
  		}



    .list-group{
    	--bs-list-group-border-radius:0 0 0 0 !important;
    }




    .list-group{
    	--bs-list-group-border-radius:0 0 0 0 !important;
    }

    .list-group-item{
    	border-radius: 0 0 0 0 ;
    	border: none !important;
    	padding:  0 0 0 0 !important;

    	height: 3rem;
    	line-height:3rem;
    	font-size: 14px;
    	color: #666666;
    	border-bottom: solid  1px #E6EAEC !important;
    }
    .list-group-item:first-child{
    	border-top-left-radius: 0;
    	border-top-right-radius: 0;

    }

    .userliebiao{
    	display: flex;
    	font-size: 12px;
    	height: auto;

    	background-color: white;
    }
    textarea:focus {
        outline: none;
      }
    .form-control{
    	 border: none !important;
    	font-size: 14px;
    	height: 3rem;

    }
    .form-control:focus {
        outline: none;
        border-color: #ccc;
        border: none;
        -webkit-box-shadow: none;
        box-shadow: none;
    }

     .uinfo{
     	width: 94%;
       margin:  0 auto;
     	height: auto;
     	padding-top: 5px;
     	padding-bottom: 5px;
     	background-color: white;
       box-shadow: 5px 5px 5px 5px #ccc;
       border-radius: 5px 5px 5px 5px;
       margin-top: 15px;
     }
     .uinfo_1{
     	width: 90%;
     	height: auto;
     	margin: 0 auto;
      font-size: 14px;
     }

     .zixun{
       width: 30%;
       height: 2rem;
       border-radius: 5px 5px 5px 5px;
       background-color: #00DDA3;
       text-align: center;
       line-height: 2rem;
       color:white;
       font-weight:bold;
      /* border: solid 1px #057E5A; */
       float: right;
      margin-top: 0.5rem;
       box-shadow: 2px 2px 2px 2px #ccc;
     }
     .zxnr{
       width: 100%;
       height: auto;
       min-height: 160px;
       line-height: 20px !important;
       padding-top: 10px;
       border: none;
       padding:.375rem .75rem;
       padding-top: 1rem;
       font-size: 14px;
     }
     .zzz{
       width: 30%;
       height: 35px;
       margin: 0 auto;
       text-align: center;
       line-height: 35px;
       background-color: #00DDA3;
       color: white;
       border-radius: 5px 5px 5px 5px;
       margin-top: 20px;
       margin-bottom: 15px;
     }
</style>



// WEBPACK FOOTER //
// src/views/user/zixun.vue